import React from 'react';
import { useHistory } from 'react-router-dom';

import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import Image from 'atoms/Image';
import { ButtonComp } from 'atoms/Buttons';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { redirectToMenuPage } from 'common/utilities/utils';

const EmptyMessagePlaceHolder = props => {
  const params = { history: useHistory() };
  const {
    placeHolderText = TRANSLATE_MAPPING_KEY?.YOUR_CART_EMPTY,
    buttonLabel = TRANSLATE_MAPPING_KEY?.START_ORDER,
    onBtnClickHandler = () => redirectToMenuPage(params),
  } = props;

  return (
    <div className='cart-empty-placeholder cart-empty-root'>
      <div className='cart-empty-placeholder-view'>
        <span className='cart-empty-placeholder-text'>{translateWithI18Next(placeHolderText)}</span>
        <ButtonComp
          className='button redButton start-order-btn cart-empty-placeholder-button'
          aria-label={translateWithI18Next(buttonLabel)}
          onClickHandler={onBtnClickHandler}
          id='startOrderItemButton'
          type='submit'
          data-testid='empty-cart-start-order-button'
        >
          <span>{translateWithI18Next(buttonLabel)}</span>
        </ButtonComp>
      </div>
      <Image className='cart-empty-img' srcFile={IMAGE_PATH?.EmptyCartImage} altText='' />
    </div>
  );
};

export default React.memo(EmptyMessagePlaceHolder);
